import CoverSlide from './cover'
export default CoverSlide
